import type { BookingMode } from '~/domain/availability/index.server';

/**
 * Per-visit checkout context shared with the Amplitude enrichment plugin so
 * every `Checkout *` event carries `experience_id` + `booking_mode` (global
 * tracking-plan properties that aren't part of the typed per-event payloads).
 *
 * Set by the checkout layout (client-only) on each navigation; read by the
 * enrichment when an event is sent. Only checkout events are stamped, and they
 * only fire while the layout is mounted, so a stale value is never read.
 */
type CheckoutAnalyticsContext = {
  experienceId?: string;
  /** Still pending on a step that streams its booking mode in after it
   *  renders; the enrichment waits for it. `null` when it could not be read. */
  bookingMode?: BookingMode | Promise<BookingMode | null>;
};

let context: CheckoutAnalyticsContext = {};

export function setCheckoutAnalyticsContext(next: CheckoutAnalyticsContext) {
  context = next;
}

export function getCheckoutAnalyticsContext(): CheckoutAnalyticsContext {
  return context;
}
